import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  @Input() searchBarClass: string | undefined;
  @Input() inputValue: string | undefined;
  @Input() placeholder: string = "..."
  @Output() searchQuery: EventEmitter<string> = new EventEmitter();
  isLoading: boolean = false;
  showEmptyState: boolean = false;
  @Input() items: any = [];
  @Input() id: string = "searchQuery";

  constructor(public translocoService: TranslocoService) {
  }

}
